var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Edit "+_vm._s(_vm.activeSurvey.title))]),_vm._v(" "),_c('vue-form-generator',{staticClass:"vue-form-generator--admin",attrs:{"schema":_vm.buildSchema('survey', 'surveySchema', 'basicInfo', 'edit'),"model":_vm.formModel,"options":_vm.formOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }